import type { ResendMagicLinkEmailResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils';

import { zodResendMagicLinkEmailResponseSchema } from './validations';

/**
 * Resend magic link email to the supplier.
 * Regenerates token and resends email. Only valid for REQUESTED status.
 *
 * @param callOffId - The call-off ID.
 * @returns null on success.
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Off-Magic-Link/operation/resend_magic_link_email_calloffs__calloff_id__magic_link_resend_post
 */
export const resendMagicLinkEmail = async (callOffId: UUID) => {
  const response = await vestigasApi
    .post(ENDPOINT.CALL_OFF.RESEND_MAGIC_LINK(callOffId))
    .json<ResendMagicLinkEmailResponse>();

  const validatedResponse =
    zodResendMagicLinkEmailResponseSchema.safeParse(response);
  if (validatedResponse?.error?.issues?.length) {
    log.error({
      message: 'Resend Magic Link Email API response has validation errors',
      error: {
        errors: validatedResponse?.error?.issues,
        errorMessage: validatedResponse?.error?.message,
        response,
      },
    });
  }

  return response;
};
